import React from 'react';
import Lock from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/lock.svg';
import Unlock from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/unlock.svg';
// import CopyGold from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/copy-gold.svg';
import Icon from 'components/canvas/components/icon';
import { useTranslation } from 'i18n';
import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { toast } from 'services/toast';
import { KonvaEventObject } from 'konva/lib/Node';
import { SurfaceBackgroundNode, SurfaceNodeUnion } from 'graphql/types';
import useSaveSurfaceBackgroundNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-background-node';

export interface LockIconProps {
  node?: SurfaceNodeUnion;
  isSelected?: boolean;
  onClick?: (event: KonvaEventObject<MouseEvent>) => void;
  width?: number;
  height?: number;
}

const defaultProps = {
  isSelected: false,
};

function LockIcon(props: LockIconProps) {
  const { t } = useTranslation();
  const { node } = props;
  const x =  node as SurfaceBackgroundNode
  const { addNodesForCopyToClipboard } = useCanvasClipboardOperations();
  const saveSurfaceImageNode = useSaveSurfaceBackgroundNode("");
  const { clearSelectedNode } = useSelectedNodeOperations();
  const [isSelected, setSelected] = React.useState<boolean>(false);

  const src = !x.isFixed ? Lock : Unlock;

  async function copyNode(node) {
    if (node) {
      toast.success(
        t(node.isFixed?`Background Unocked `: `Background Locked `, {
          replace: { name: node?.name || '' },
        }),
      );
      //addNodesForCopyToClipboard([node]);
      console.warn(" UPDaTE NODE ", node)
      const input =   {id:node.id,
        name:node.name,
      isFixed:!node.isFixed
      }
      const response = await saveSurfaceImageNode({ variables: { input } });

      if (response.isFailure) {
       // setSubmitting(false);
        toast.error(response.getErrorMessage());
  
        return response;
      }
      clearSelectedNode();
    }
  }

  function onClick(event) {
    event.cancelBubble = true;

    if (node) {
      copyNode(node);
    }

    props.onClick && props.onClick(event);
  }

  return (
    <Icon
      {...props}
      src={src}
      onClick={onClick}
    /*   onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)} */
    />
  );
}

LockIcon.defaultProps = defaultProps;

export default LockIcon;
